import { Box, Typography } from "@mui/material";
import React from "react";
import ErrorIcon from "../../../assets/auradine_error.svg";
import { BodySmall } from "../Typography/Typography.tsx";

type AuradineErrorStateProps = {
  message: string;
  fontSize?: string;
};

const AuradineErrorState: React.FC<
  AuradineErrorStateProps
> = (
  props: AuradineErrorStateProps
): React.ReactElement => {
  const { message } = props;
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent={"center"}
      alignItems={"center"}
      alignContent={"center"}
      gap={4}
      height={"100%"}
      flexWrap={"wrap"}
    >
      <img
        style={{
          width: "auto",
          height: "auto",
          maxHeight: "20rem",
        }}
        src={ErrorIcon}
        alt="empty basket"
      />
      <BodySmall
        style={{
          fontSize: props.fontSize
            ? props.fontSize
            : "1.375rem",
          fontWeight: 400,
        }}
      >
        {message}
      </BodySmall>
    </Box>
  );
};

export default AuradineErrorState;
